/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { Stack } from "@mui/material";
import { ComponentImageLinkContext } from "./component-image-link-context";
import { ListImage } from "./list-image";
import { ImageListLink } from "./image-list-link";
// import { useTranslation } from "react-i18next";

const ImageLinkItemEditor = () => {
    // const { t } = useTranslation();
    const componentImageLinkContext = useContext(ComponentImageLinkContext);
    const index = componentImageLinkContext?.index;
    const position = componentImageLinkContext?.position;
    const item = componentImageLinkContext?.item;
    const updateItemByPosition = componentImageLinkContext?.updateItemByPosition;
    const _image = item?.image;
    const _link = item?.link;

    const [image, setImage] = useState(_image); // guid
    const [link, setLink] = useState(_link);

    const updateImage = (guid) => {
        setImage(guid);
    };

    const updateLink = async (newLink) => {
        setLink(newLink);
    };

    useEffect(
        () => {
            const nextItem = structuredClone({
                ...item,
                image,
                link,
            });
            updateItemByPosition(nextItem, position);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [link, image]
    );

    return (
        <div className="simplicity-image-link-item">
            <Stack direction="row" justifyContent="flex-start">
                <div className="simplicity-image-link-item-image"></div>
                <div className="simplicity-image-link-item-data">
                    <div className="list-image">
                        <ListImage index={index} image={image} updateImage={updateImage} />
                    </div>
                    <div className="list-links">
                        <ImageListLink index={index} link={link} updateLink={updateLink} />
                    </div>
                </div>
            </Stack>
        </div>
    );
};
ImageLinkItemEditor.displayName = "ImageLinkItemEditor";
export { ImageLinkItemEditor };
